import type { LanguageCode } from '@repo/domain';
import { FlagPolandIcon, FlagUnitedKingdomIcon } from '@repo/icons';

import type { LanguageOption } from '@shared/types/language';

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: 'pl', label: 'Polski', flag: FlagPolandIcon, localePrefixes: ['pl'], isDefault: false },
  { value: 'en', label: 'English', flag: FlagUnitedKingdomIcon, localePrefixes: ['en'], isDefault: true },
];

export const LANGUAGE_CODES = LANGUAGE_OPTIONS.map((option) => option.value) as [LanguageCode, ...LanguageCode[]];
